export const DEVICE_DATA_LIMIT = 'DEVICE_DATA_LIMIT' as const;
export const DEVICE_USAGE = 'DEVICE_USAGE' as const;
export const TAC_CHANGE = 'TAC_CHANGE' as const;
